import MfgEquipment from '@/pages/mfg/Equipment';
import { DepartmentProvider } from '@/pages/mfg/DepartmentContext';

/**
 * 設備 — ひとつの台帳・ひとつの画面（2026-10-21）。
 *
 * 技術 | 製造 のタブ切替は廃止した。保存先も画面も 1 つで、部署の絞り込み
 * （すべて / SNS / SOL / HTR / ENG / CMN）だけで見え方を変える。
 * 技術のメニューから来たときは ENG を選んだ状態で開く。
 */
export default function EquipmentHub({ side = 'eng' }) {
  return (
    <div data-testid="equipment-hub">
      <DepartmentProvider>
        <MfgEquipment deptCode={side === 'eng' ? 'ENG' : ''} />
      </DepartmentProvider>
    </div>
  );
}
